import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Scheduler } from 'rxjs/Scheduler';
import { CalendarService } from '@finder/shared/services/calendar-service/calendar-service.service';
import { CurrencyConverterService } from '@finder/shared/components/currency-converter/currency-converter.service';
import { FeatureDetectionService } from '@finder/shared/services/feature-detection/feature-detection.service';
import { FinderLayoutComponent } from '@finder/shared/components/finder-layout/finder-layout.component';
import { FontIconLoaderComponent } from '@finder/shared/components/font-icon-loader/font-icon-loader.component';
import { HeaderOverridesService } from '@finder/shared/services/header-overrides/header-overrides.service';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { ParallaxBackgroundService } from '@finder/shared/components/parallax-background/parallax-background.service';
import { SyndicatedFooterComponent } from '@finder/shared/components/syndicated-layout/syndicated-footer/syndicated-footer.component';
import { SyndicatedHeaderComponent } from '@finder/shared/components/syndicated-layout/syndicated-header/syndicated-header.component';
import { SystemErrorComponent } from '@finder/shared/components/system-error/system-error.component';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { ScriptLoaderModule } from '@finder/shared/components/script-loader/script-loader.module';
import { LoadingSpinnerModule } from '@finder/shared/components/loading-spinner/loading-spinner.module';
import { CssLoaderModule } from '@finder/shared/components/css-loader/css-loader.module';
import { FinderButtonModule } from './finder-button/finder-button.module';
import { InfiniteScrollingComponent } from '@finder/shared/components/infinite-scrolling/infinite-scrolling.component';
const exportableComponents = [
    FinderLayoutComponent,
    FontIconLoaderComponent,
    SyndicatedFooterComponent,
    SyndicatedHeaderComponent,
    SystemErrorComponent,
    InfiniteScrollingComponent
];
const ɵ0 = Scheduler;
const exportableProviders = [
    { provide: Scheduler, useValue: ɵ0 },
    CalendarService,
    CurrencyConverterService,
    CurrencyPipe,
    DecimalPipe,
    FeatureDetectionService,
    HeaderOverridesService,
    ModalService,
    ParallaxBackgroundService,
    WindowRef,
];
const exportableModules = [
    ScriptLoaderModule,
    LoadingSpinnerModule,
    CssLoaderModule,
    FinderButtonModule,
];
export class ComponentsModule {
}
export { ɵ0 };
